<template>
  <div v-if="list.length <= 5">
    <div v-for="(item, index) in list.slice(1)">
      <div>{{item.number}}</div>
    </div>
  </div>
  <div v-else>
    <div v-for="(item, index) in list.slice(1)">
      <div v-if="index <= 5">{{item.number}}</div>
    </div>
    <div>
      <button class="b-btn b-btn_type_empty px-0" @click="isShowList = !isShowList" v-if="!isShowList">
        <div>{{$t('CONTENT.show_more')}} {{list.length - 6}}</div>
      </button>
      <transition name="fade">
        <div v-if="isShowList">
          <div v-for="(item, index) in list.slice(5)">
            <div>{{item.number}}</div>
          </div>
        </div>
      </transition>
      <button class="b-btn b-btn_type_empty px-0" @click="isShowList = !isShowList" v-if="isShowList">
        <div>{{$t('CONTENT.hide')}}</div>
      </button>
    </div>
  </div>
</template>

<script>
	export default {
		props: {
		  list: {
		    type: Array,
      }
    },
    data() {
      return {
        isShowList: false,
      }
    },
	}
</script>
